module.exports = __webpack_public_path__ + "img/shareImg2.7ae605bd.png";